export const refreshTryLuca = ({ delayMs = 0 } = {}) => {
  if (typeof window === 'undefined') return

  const reloadApp = () => {
    window.location.reload()
  }

  if (delayMs > 0) {
    window.setTimeout(reloadApp, delayMs)
    return
  }

  reloadApp()
}
